export default {
  jobsRecommendedPerson: (state) => state.jobsRecommendedPerson,
  cachedJobsRecommendedPerson: (state) => state.cachedJobsRecommendedPerson,
  recommendationsByJob: (state) => state.recommendationsByJob,
  cachedRecommendationsByJob: (state) => state.cachedRecommendationsByJob,

  jobsIWasIndicatedPerson: (state) => state.jobsIWasIndicatedPerson,
  cachedJobsIWasIndicatedPerson: (state) => state.cachedJobsIWasIndicatedPerson,
  indicationsIReceivedByJob: (state) => state.indicationsIReceivedByJob,
  cachedIndicationsIReceivedByJob: (state) => state.cachedIndicationsIReceivedByJob,
};
